/* ============================================================================
   PZ Holiday "Build Your Bundle" page — Phase 1 (front end only). Round 2.
   Theme: Copy of OG | PDP + LP Improvements final V5 270926 (186524041325)
   Loads only on templates/page.holiday-bundle.json via
   sections/holiday-bundle-builder.liquid. Vanilla JS, no dependencies.

   The basket IS the real Shopify cart (/cart.js, /cart/add.js, /cart/change.js).
   Tier + gift states are DISPLAY ONLY. This file never adds or removes gift
   lines — the EG Auto Add to Cart app does that in Phase 2.

   The product grid is rendered by the section in Liquid (one card per shade,
   collection-page markup). This file handles: tabs, NEW badges, the swatch cap,
   the price-in-button, the stepper, add-to-cart states, and the basket.
   Shade switching itself is the theme's product-card-swatch.js (image / price /
   hidden id) + pz-variant-card.js (title / description), exactly as the
   category page; this file listens for its pz:variant-card:change event.
   ============================================================================ */
(function () {
  'use strict';
  // exactly one instance per page (guards against a second include / section re-render)
  if (window.__pzHB) { console.warn('[PZ-HB] second initialisation blocked'); return; }
  window.__pzHB = { booted: Date.now() };

  /* ==========================================================================
     CONFIG — every number and every piece of copy on the page comes from here.
     "TBC" marks Phase-2 placeholders still to be filled.
     ========================================================================== */
  var PZ_HB_CONFIG = {
    currencyCode: 'USD',
    currencySymbol: '$',
    currencySymbols: { USD: '$', GBP: '£', EUR: '€' },

    // Tier 1: free shipping only (no gift product). image: null = the photo the
    // blush PDP "Free with your set" row uses (theme setting pz_r3_freeship_img,
    // resolved by the section into data-pz-hb-ship-img).
    // Free shipping minimum per market = the store's shipping rates ("order total ≥", delivery profile, Oct 2026):
    // US $45, UK £50, EU €75, rest of world $75 (USD-priced zone, converted + rounded up for other currencies).
    // A currency with no entry and no rowUsd would hide the free-shipping tier.
    shipping: {
      threshold: 45,          // USD (kept for reference / fallback)
      byCurrency: { USD: 45, GBP: 50, EUR: 75 },
      rowUsd: 75,
      label: 'Free shipping',
      short: 'shipping',
      helperUnlocked: 'On this order',
      image: null
    },

    // FIXED gift-tier thresholds per currency (Round 13, frozen 5 Oct 2026 from the rounded-up rates). One amount per
    // gift, in config order. Type the same amounts into the EG Auto Add to Cart rules for each market. A currency
    // not listed here falls back to the live rate: USD threshold × Shopify.currency.rate, rounded UP to the unit.
    giftThresholdsByCurrency: {
      USD: [45, 52, 65, 80, 100].slice(1), // USD = the gifts' own thresholds below (52 / 65 / 80 / 100)
      EUR: [48, 60, 73, 92],
      GBP: [40, 50, 61, 76]
    },

    // Tiers 2–5: ONE ENTRY PER GIFT TIER, cumulative and fixed. Read everywhere.
    gifts: [
      {
        threshold: 52,
        name: 'Chrome Eyeshadow', plural: 'Chrome Eyeshadows',
        nameShort: 'Chrome', pluralShort: 'Chromes',           // tier-card label (one line)
        nameMobile: 'eyeshadow', pluralMobile: 'eyeshadows',
        shade: 'Godmother',
        priceHandle: 'chrome-eyeshadows', // gift value = this product's price in the visitor's market (value below = fallback)
        value: 20,
        variantId: 'TBC', // new Chrome range gift variant (old range: 41872429711469)
        image: 'https://cdn.shopify.com/s/files/1/0248/4889/2013/files/Frame8_de468ea5-084d-43d8-a507-7686e67e301c.png?v=1704707596&width=320', // TBC: old Cream Chrome shot
        label: 'Free Chrome Eyeshadow', mobileLabel: 'Free eyeshadow',
        phrase: 'a free Chrome Eyeshadow'
      },
      {
        threshold: 65,
        name: 'Chrome Eyeshadow', plural: 'Chrome Eyeshadows',
        nameShort: 'Chrome', pluralShort: 'Chromes',
        nameMobile: 'eyeshadow', pluralMobile: 'eyeshadows',
        shade: 'Rockstar',
        priceHandle: 'chrome-eyeshadows', // gift value = this product's price in the visitor's market (value below = fallback)
        value: 20,
        variantId: 'TBC', // new Chrome range gift variant (old range: 41872429908077)
        image: 'https://cdn.shopify.com/s/files/1/0248/4889/2013/files/Rockstar2_b9b76b31-0c74-4f7c-ba93-97f779541fc1.jpg?v=1713429007&width=320', // TBC: old Cream Chrome shot
        label: '2nd free Chrome Eyeshadow', mobileLabel: '2nd free eyeshadow',
        phrase: 'a 2nd free Chrome Eyeshadow'
      },
      {
        threshold: 80,
        name: 'Quad Palette', plural: 'Quad Palettes',
        nameShort: 'Palette', pluralShort: 'Palettes',
        nameMobile: 'palette', pluralMobile: 'palettes',
        shade: 'San Blas', // TESTING PLACEHOLDER — will change
        priceHandle: 'quad-eyeshadow-palette', // gift value = this product's price in the visitor's market (value below = fallback)
        value: 30,
        variantId: 'TBC', // FREE - Quad Eyeshadow Palette / San Blas = 41047529160813 (confirm)
        image: 'https://cdn.shopify.com/s/files/1/0248/4889/2013/files/SanBlascopy.png?v=1760351026&width=320',
        label: 'Free Quad Eyeshadow Palette', mobileLabel: 'Free palette',
        phrase: 'a free Quad Eyeshadow Palette'
      },
      {
        threshold: 100,
        name: 'Quad Palette', plural: 'Quad Palettes',
        nameShort: 'Palette', pluralShort: 'Palettes',
        nameMobile: 'palette', pluralMobile: 'palettes',
        shade: 'Bombay Rose', // TESTING PLACEHOLDER — will change
        priceHandle: 'quad-eyeshadow-palette', // gift value = this product's price in the visitor's market (value below = fallback)
        value: 30,
        variantId: 'TBC', // FREE - Quad Eyeshadow Palette / Bombay Rose = 41047529128045 (confirm)
        image: 'https://cdn.shopify.com/s/files/1/0248/4889/2013/files/Bombaycopy.png?v=1760351026&width=320',
        label: '2nd free Quad Eyeshadow Palette', mobileLabel: '2nd free palette',
        phrase: 'a 2nd free Quad Eyeshadow Palette'
      }
    ],

    // How the page recognises gift lines the EG Auto Add to Cart app puts in the cart
    // (never counted toward thresholds, never shown as products):
    //  - line property key "_Gifted" (EG's addedItemIdentifier; value = rule name)
    //  - line property "_freeGift" (theme's own dormant auto-gift)
    //  - the gift variant IDs listed above
    //  - product handle containing "free-gift" (mirrors cart-drawer-item.liquid)
    giftLineMarkers: {
      propertyKeys: ['_Gifted', '_freeGift'],
      handleContains: ['free-gift']
    },

    copy: {
      announcement: 'Free gifts worth up to {total} this holiday season',
      announcementMobile: 'Free gifts worth up to {total}',
      kicker: 'Holiday 2026',
      headline: 'Build your holiday bundle',
      subline: 'Spend {top}, get {total} of makeup free.',
      note: 'Gifts added automatically. Shades as shown.',

      progressShipping: 'Add **{gap}** to unlock free shipping.',
      progressGift: 'Add **{gap}** to unlock {phrase}.',
      progressStretch: 'Spend **{gap} more**, get {value} more free.',
      progressDone: "You've unlocked everything. **{total} of gifts** added.",

      nudgeShipping: '{gap} more for free shipping',
      nudgeGift: '{gap} more for {phrase}',
      nudgeDone: 'Every gift is in your bundle.',

      toastShipping: "You've unlocked free shipping.",
      toastGift: "You've unlocked {phrase}.",
      toastBoth: "You've unlocked free shipping and {phrase}.",   // tied tier (free shipping + gift at the same amount)
      progressBoth: 'Add **{gap}** to unlock free shipping and {phrase}.',
      nudgeBoth: '{gap} more for free shipping and {phrase}',
      tierBoth: 'Free Shipping + {giftLine}',                      // tier-card line 1 on a tied tier

      basketTitle: 'Your bundle',
      productsLabel: 'Your products',
      giftsLabel: 'Your free gifts',
      unlockedShort: '{n} of {total} unlocked',
      unlockedLong: '{n} of {total} gifts unlocked',
      emptyTitle: 'Start adding to unlock your gifts',
      emptyNote: 'Your first gift unlocks at {first}.',
      subtotal: 'Subtotal',
      shippingRow: 'Shipping',
      shippingFree: 'FREE',
      giftsRow: 'Free gifts',
      giftsValue: '{value} value',
      total: 'Total',
      checkout: 'Checkout',
      morePayment: 'More payment options',
      giftsFooter: 'Gifts added automatically at checkout.',
      viewBag: 'View bag',
      items: '{n} items', item: '1 item',
      toGo: '{gap} to go', unlocked: 'Unlocked',
      unlocksAt: 'Unlocks at {t}',
      bestValue: 'Best value', locked: 'Locked', free: 'FREE', newBadge: 'New',
      tierShipping: 'Free Shipping', tierGift: '{value} Free Gift', tierGifts: '{value} Free Gifts', // tier-card line 1
      slotGift: '{value} Free Gift', // basket gift slot line 1 (line 2 = ordinal + gift name)
      addDesktop: 'Add to bundle', addMobile: 'Add', added: 'Added', soldOut: 'Sold Out', // Sold Out = collection card label
      footer: 'Free shipping over {ship} · Gifts while stocks last'
    },

    // Filter tabs. match(card) gets { title, tags[], type, handle } from the card's data attributes.
    tabs: [
      { id: 'all',      label: 'All',      match: function () { return true; } },
      { id: 'new',      label: 'New',      match: function (p) { return hasTag(p, ['new', 'badge:new']) || PZ_HB_CONFIG.newHandles.indexOf(p.handle) >= 0; } },
      { id: 'blush',    label: 'Blush',    match: function (p) { return /blush/i.test(p.title) || hasTag(p, ['blush', 'blushes', 'blusher', 'blushers', 'powder blushes']); } },
      { id: 'bronzer',  label: 'Bronzer',  match: function (p) { return /bronzer/i.test(p.title) || hasTag(p, ['bronzer', 'bronzers']); } },
      // EYES = members of the theme's "eyes" collection, plus anything typed/tagged/titled as an eye product
      { id: 'eyes',     label: 'Eyes',     match: function (p) { return hasCollection(p, ['eyes']) || /eyeshadow|eye shadow|palette|chrome|liner|mascara|brow/i.test(p.title + ' ' + p.type) || hasTag(p, ['eyes', 'eye', 'eyeshadow', 'palette', 'palettes']); } },
      { id: 'brushes',  label: 'Brushes',  match: function (p) { return /brush/i.test(p.title) || hasTag(p, ['brush', 'brushes']); } }
    ],
    newHandles: ['chrome-eyeshadows'], // TBC: new Chrome range handle
    // used only if Shopify.currency.rate is missing: local price of this product ÷ its USD price ≈ presentment rate
    rateReference: { handle: 'quad-eyeshadow-palette', usdCents: 3000 },

    // Mobile tier-strip layout: 'pairs' = 2+2+full-width best card, 'scroll' = horizontal swipe row with the next card peeking, 'stack' = 3+full+full
    mobileTierLayout: 'pairs',

    // Behaviour
    swatchLimit: 0,        // 0 = every shade swatch visible (Round 3); >0 caps with "+N" like the collection page
    maxLineQty: 12,
    maxStepperQty: 9,
    toastMs: 3200,
    addedMs: 1500,         // "ADDED" confirmation on the card button
    resyncDelaysMs: [600, 2200, 4500] // re-read /cart.js after each write (the app settles within ~2s)
  };

  /* ========================================================================
     Tier model — built for the visitor's currency (Round 10):
       • gift tiers: USD threshold × Shopify presentment rate, ROUNDED UP to the whole unit (USD unchanged)
       • free-shipping tier: the real shipping minimum for that market (CFG.shipping.byCurrency), else rowUsd converted
       • gift values: the gift product's localized price (data-pz-hb-prices), falling back to the config value in USD
       • tiers are ordered by local threshold, so free shipping can sit anywhere in the row
     ======================================================================== */
  var CFG = PZ_HB_CONFIG;
  var TIERLIST = [], TIERS = [], N = 0, POS = [], TOTAL_GIFT_VALUE = 0, TOP = 0, V = {};
  var LOCAL_PRICES = {};
  function hasTag(p, list) {
    var tags = (p.tags || []).map(function (t) { return String(t).toLowerCase(); });
    return list.some(function (t) { return tags.indexOf(t.toLowerCase()) >= 0; });
  }
  function hasCollection(p, list) {
    var cols = (p.collections || []).map(function (c) { return String(c).toLowerCase(); });
    return list.some(function (c) { return cols.indexOf(c.toLowerCase()) >= 0; });
  }

  /* ========================================================================
     Utilities
     ======================================================================== */
  var root = document.querySelector('[data-pz-hb]');
  if (!root) return;
  if (!CFG.shipping.image) CFG.shipping.image = root.getAttribute('data-pz-hb-ship-img') || '';
  try { LOCAL_PRICES = JSON.parse(root.getAttribute('data-pz-hb-prices') || '{}') || {}; } catch (e) { LOCAL_PRICES = {}; }
  var isMobile = function () { return window.matchMedia('(max-width: 1023px)').matches; };
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var activeCurrency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || CFG.currencyCode;
  var priceSym = CFG.currencySymbols[activeCurrency] || (activeCurrency + ' ');
  function setCartCurrency(code) { if (!code || code === activeCurrency) return; activeCurrency = code; priceSym = CFG.currencySymbols[code] || (code + ' '); buildModel(); renderStatic(); lastKeys = { tiers: '', prog: '', basket: '', toast: '' }; }
  // Presentment rate: Shopify.currency.rate = units of the active currency per 1 USD (shop currency). The EG app
  // evaluates its cartValue triggers the same way: threshold × rate, truncated to cents, against the presentment
  // cart value — so page and app unlock at the same point.
  var fxWarned = false;
  function fxRate() {
    if (activeCurrency === CFG.currencyCode) return 1;
    var sc = window.Shopify && window.Shopify.currency;
    var r = sc && sc.active === activeCurrency ? parseFloat(sc.rate) : NaN;
    if (r > 0) return r;
    // fallback: ratio of a reference product's localized price to its USD price (market prices track the rate closely)
    var ref = CFG.rateReference, local = ref && LOCAL_PRICES[ref.handle];
    if (local > 0 && ref.usdCents > 0) r = local / ref.usdCents;
    if (!(r > 0)) r = 1;
    if (!fxWarned) { fxWarned = true; console.warn('[PZ-HB] Shopify.currency.rate unavailable for ' + activeCurrency + ' (Shopify.currency=' + JSON.stringify(sc) + '); using ' + r); }
    return r;
  }
  function thresholdCents(usd) { return parseInt(usd * 100 * fxRate(), 10); }   // USD tier → presentment cents (EG's pe())
  function usdFromCents(c) { return c / fxRate() / 100; }                       // presentment cents → USD
  function convUp(usd) { return activeCurrency === CFG.currencyCode ? usd : Math.ceil(usd * fxRate() - 1e-9); } // whole units, rounded up
  function giftValueLocal(g) {
    var cents = g.priceHandle && LOCAL_PRICES[g.priceHandle];
    if (cents != null && cents > 0) return cents / 100;          // the product's price in this market
    return activeCurrency === CFG.currencyCode ? g.value : convUp(g.value); // fallback only
  }
  function buildModel() {
    // one entry per gift tier, plus the market's free-shipping minimum; entries at the SAME local
    // threshold merge into one tier (e.g. GBP: free shipping £50 + 2nd Chrome £50)
    var fixed = CFG.giftThresholdsByCurrency[activeCurrency];
    var entries = CFG.gifts.map(function (g, i) { var th = fixed && fixed[i] != null ? fixed[i] : convUp(g.threshold); return { threshold: th, gift: { gi: i, gift: g, value: giftValueLocal(g) }, ship: false }; });
    var shipT = CFG.shipping.byCurrency[activeCurrency];
    if (shipT == null && CFG.shipping.rowUsd != null) shipT = convUp(CFG.shipping.rowUsd);
    if (shipT != null) entries.push({ threshold: shipT, gift: null, ship: true });
    entries.sort(function (a, b) { return a.threshold - b.threshold || (a.ship ? -1 : 1); });
    var list = [];
    entries.forEach(function (e) {
      var last = list[list.length - 1];
      if (last && last.threshold === e.threshold) { if (e.ship) last.ship = true; if (e.gift) last.gifts.push(e.gift); return; }
      list.push({ threshold: e.threshold, ship: e.ship, gifts: e.gift ? [e.gift] : [] });
    });
    list.forEach(function (tr) { tr.kind = tr.ship && tr.gifts.length ? 'both' : (tr.ship ? 'ship' : 'gift'); tr.value = tr.gifts.reduce(function (s, x) { return s + x.value; }, 0); });
    TIERLIST = list; TIERS = list.map(function (x) { return x.threshold; }); N = TIERS.length;
    POS = TIERS.map(function (_, i) { return Math.round((i + 1) / N * 10000) / 100; });
    TOTAL_GIFT_VALUE = list.reduce(function (s, x) { return s + x.value; }, 0);
    TOP = TIERS[N - 1];
    var ship = list.filter(function (x) { return x.ship; })[0];
    V = { total: money(TOTAL_GIFT_VALUE), top: money(TOP), ship: ship ? money(ship.threshold) : '', first: money(TIERS[0]) };
    root.setAttribute('data-pz-hb-model', activeCurrency + ' rate=' + fxRate() + ' tiers=' + list.map(function (x) { return x.threshold + (x.kind === 'ship' ? 's' : x.kind === 'both' ? 'b' : ''); }).join('/'));
    // basket slots: free shipping + one per gift, in unlock order
    SLOTS = [];
    list.forEach(function (tr, i) { if (tr.ship) SLOTS.push({ ship: true, tier: i, threshold: tr.threshold }); tr.gifts.forEach(function (x) { SLOTS.push({ ship: false, tier: i, threshold: tr.threshold, g: x.gift, gi: x.gi, value: x.value }); }); });
  }
  var SLOTS = [];
  function giftsUpTo(i) { var out = []; TIERLIST.slice(0, i + 1).forEach(function (tr) { out = out.concat(tr.gifts); }); return out; }
  function tierPhrase(tr) { return tr.gifts.length ? tr.gifts[tr.gifts.length - 1].gift.phrase : ''; }

  function money(n, sym) {
    var r = Math.round(n * 100) / 100;
    return (sym || priceSym) + (r % 1 === 0 ? String(r) : r.toFixed(2));
  }
  function priceFromCents(c) { return money(c / 100, priceSym); }
  function price2(c) { return priceSym + (c / 100).toFixed(2); } // card button: "$26.00" like the collection page
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch];
    });
  }
  function tpl(str, vars, html) {
    var out = str.replace(/\{(\w+)\}/g, function (_, k) { return vars[k] != null ? vars[k] : ''; });
    if (html) return out.replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>');
    return out.replace(/\*\*/g, '');
  }
  function upper(s) { return String(s).toUpperCase(); }
  function debounce(fn, ms) { var t; return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, ms); }; }
  function imgW(url, w) { if (!url) return ''; return url + (url.indexOf('?') >= 0 ? '&' : '?') + 'width=' + w; }

  function svg(body, size, sw) {
    return '<svg width="' + size + '" height="' + size + '" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="' + (sw || 2) + '" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' + body + '</svg>';
  }
  var I = {
    lock: '<rect x="5" y="11" width="14" height="10" rx="2"></rect><path d="M8 11V7a4 4 0 0 1 8 0v4"></path>',
    tick: '<path d="M5 12.5l4.5 4.5L19 7.5"></path>',
    truck: '<path d="M2 6h12v10H2z"></path><path d="M14 9h4.5L22 12.5V16h-8"></path><circle cx="6" cy="18" r="2"></circle><circle cx="17.5" cy="18" r="2"></circle>',
    gift: '<rect x="3" y="9" width="18" height="12" rx="1"></rect><path d="M3 13h18"></path><path d="M12 9v12"></path><path d="M12 9C10.5 5 6 4.5 6.5 7.3 7 9 12 9 12 9z"></path><path d="M12 9c1.5-4 6-4.5 5.5-1.7C17 9 12 9 12 9z"></path>',
    plus: '<path d="M12 5v14"></path><path d="M5 12h14"></path>',
    minus: '<path d="M5 12h14"></path>'
  };

  var $ = function (sel, ctx) { return (ctx || root).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || root).querySelectorAll(sel)); };

  /* ========================================================================
     State
     ======================================================================== */
  var state = { cart: null, lastPaid: null, maxUnlocked: null, tab: 'all', sheet: false, toast: -1, fresh: -1, asideMode: 'full' };
  var toastTimer = null;

  /* ========================================================================
     Cart maths — paid lines only
     ======================================================================== */
  function isGiftLine(item) {
    var props = item.properties || {};
    var keys = CFG.giftLineMarkers.propertyKeys;
    for (var i = 0; i < keys.length; i++) if (Object.prototype.hasOwnProperty.call(props, keys[i])) return true;
    var ids = CFG.gifts.map(function (g) { return String(g.variantId); });
    if (ids.indexOf(String(item.variant_id || item.id)) >= 0) return true;
    var h = String(item.handle || '');
    for (var j = 0; j < CFG.giftLineMarkers.handleContains.length; j++) if (h.indexOf(CFG.giftLineMarkers.handleContains[j]) >= 0) return true;
    return false;
  }
  function paidLines(cart) { return (cart && cart.items ? cart.items : []).filter(function (it) { return !isGiftLine(it); }); }
  function paidCents(cart) {
    return paidLines(cart).reduce(function (s, it) { return s + (it.final_line_price != null ? it.final_line_price : it.line_price || 0); }, 0);
  }
  function paidSubtotal(cart) { return paidCents(cart) / 100; } // local currency
  function derive(cart) {
    var lines = paidLines(cart), cents = paidCents(cart), sub = cents / 100; // local currency
    var hit = function (i) { return cents >= TIERLIST[i].threshold * 100; };
    var unlocked = TIERS.filter(function (_, i) { return hit(i); }).length;
    var nextIdx = unlocked < N ? unlocked : -1;
    var gap = nextIdx >= 0 ? TIERS[nextIdx] - sub : 0;
    var giftValue = TIERLIST.reduce(function (v, x, i) { return v + (hit(i) ? x.value : 0); }, 0); // tier.value = its gifts' values
    var count = lines.reduce(function (s, it) { return s + it.quantity; }, 0);
    var slotsUnlocked = SLOTS.filter(function (sl) { return hit(sl.tier); }).length;
    return { lines: lines, cents: cents, sub: sub, tsub: sub, hit: hit, unlocked: unlocked, slotsUnlocked: slotsUnlocked, nextIdx: nextIdx, gap: gap, giftValue: giftValue, count: count };
  }
  function barPct(v) {
    var pts = [0].concat(TIERS), pos = [0].concat(POS);
    if (v >= TOP) return 100;
    for (var k = 1; k < pts.length; k++) {
      if (v <= pts[k]) return Math.round(pos[k - 1] + (v - pts[k - 1]) / (pts[k] - pts[k - 1]) * (pos[k] - pos[k - 1]));
    }
    return 100;
  }

  /* ========================================================================
     Copy builders
     ======================================================================== */
  function progressMsg(d) {
    if (d.nextIdx === -1) return tpl(CFG.copy.progressDone, V, true);
    var vars = Object.assign({}, V, { gap: money(d.gap) }), nt = TIERLIST[d.nextIdx];
    if (nt.kind === 'ship') return tpl(CFG.copy.progressShipping, vars, true);
    vars.phrase = tierPhrase(nt); vars.value = money(nt.value);
    if (nt.kind === 'both') return tpl(CFG.copy.progressBoth, vars, true);
    if (d.nextIdx === N - 1) return tpl(CFG.copy.progressStretch, vars, true);
    return tpl(CFG.copy.progressGift, vars, true);
  }
  function nudge(d) {
    if (d.nextIdx === -1) return tpl(CFG.copy.nudgeDone, V);
    var vars = Object.assign({}, V, { gap: money(d.gap) }), nt = TIERLIST[d.nextIdx];
    if (nt.kind === 'ship') return tpl(CFG.copy.nudgeShipping, vars);
    vars.phrase = tierPhrase(nt);
    return tpl(nt.kind === 'both' ? CFG.copy.nudgeBoth : CFG.copy.nudgeGift, vars);
  }
  function toastText(i) {
    var tr = TIERLIST[i];
    if (!tr || tr.kind === 'ship') return tpl(CFG.copy.toastShipping, V);
    return tpl(tr.kind === 'both' ? CFG.copy.toastBoth : CFG.copy.toastGift, { phrase: tierPhrase(tr) });
  }
  function tierLabel(k, mobile) {
    var gs = giftsUpTo(k); if (!gs.length) return CFG.shipping.short;
    var groups = [], map = {};
    gs.forEach(function (x) { var g = x.gift; if (!map[g.name]) { map[g.name] = { g: g, n: 0 }; groups.push(map[g.name]); } map[g.name].n++; });
    return groups.map(function (gr) {
      var one = gr.g.name, many = gr.g.plural; // same wording on mobile (Mobile Round 1): "1 Chrome Eyeshadow"
      return gr.n + ' ' + (gr.n === 1 ? one : many);
    }).join(' + ');
  }
  // basket slot line 2: "Chrome Eyeshadow", then "2nd Chrome Eyeshadow", "3rd …" for repeats of the same gift
  function slotName(gi, mobile) {
    var g = CFG.gifts[gi], n = 0;
    for (var k = 0; k <= gi; k++) if (CFG.gifts[k].name === g.name) n++;
    var ord = n === 1 ? '' : (n === 2 ? '2nd ' : n === 3 ? '3rd ' : n + 'th ');
    return ord + g.name;
  }
  function cumulativeValue(k) { return giftsUpTo(k).reduce(function (s, x) { return s + x.value; }, 0); }
  function countLabel(n) { return n === 1 ? tpl(CFG.copy.item, { n: 1 }) : tpl(CFG.copy.items, { n: n }); }

  /* ========================================================================
     Gift tile component (tier strip, basket, sheet)
     ======================================================================== */
  function giftTile(opts) {
    var locked = !opts.unlocked, text = opts.size === 'md';
    var cls = 'pz-hb-gift pz-hb-gift--' + opts.size + (locked ? ' pz-hb-gift--locked' : ' pz-hb-gift--unlocked');
    var h = '<div class="' + cls + '">';
    h += '<div class="pz-hb-gift__img' + (opts.fresh && !reduceMotion ? ' pz-hb-pop' : '') + '">';
    if (opts.isShip && !opts.image) h += '<span class="pz-hb-gift__truck">' + svg(I.truck, 32, 1.5) + '</span>';
    else h += '<img src="' + esc(opts.image) + '" alt="' + esc(opts.alt || opts.label) + '" width="160" height="160" loading="eager" decoding="async">';
    if (locked && text) h += '<span class="pz-hb-gift__pill">' + svg(I.lock, 10, 2.6) + upper(CFG.copy.locked) + '</span>';
    if (locked && !text) h += '<span class="pz-hb-gift__dot">' + svg(I.lock, 9, 2.8) + '</span>';
    if (!locked && text) h += '<span class="pz-hb-gift__tick">' + svg(I.tick, 12, 3) + '</span>';
    h += '</div>';
    if (text) {
      // line 1 bold ("$20 Free Gift" / "Free Shipping"), line 2 regular (gift name); locked = grey + "Unlocks at $X"
      h += '<div class="pz-hb-gift__text">';
      h += '<div class="pz-hb-gift__l1">' + esc(opts.line1 || opts.label) + '</div>';
      h += '<div class="pz-hb-gift__l2">' + esc(opts.line2 || '') + '</div>';
      if (opts.helper) h += '<div class="pz-hb-gift__help">' + esc(opts.helper) + '</div>';
      h += '</div>';
    }
    return h + '</div>';
  }

  /* ========================================================================
     Static copy + tier strip + progress
     ======================================================================== */
  function renderStatic() {
    var bar = document.querySelector('.m-announcement-bar__content');
    if (bar) {
      bar.innerHTML = '<span class="pz-hb-ann pz-hb-ann--d">' + esc(upper(tpl(CFG.copy.announcement, V))) + '</span>' +
                      '<span class="pz-hb-ann pz-hb-ann--m">' + esc(upper(tpl(CFG.copy.announcementMobile, V))) + '</span>';
      document.documentElement.classList.add('pz-hb-ann-ready');
    }
    $('[data-pz-hb-kicker]').textContent = upper(CFG.copy.kicker);
    $('[data-pz-hb-h1]').textContent = upper(CFG.copy.headline);
    $('[data-pz-hb-sub]').textContent = tpl(CFG.copy.subline, V);
    var note = $('[data-pz-hb-note]'); if (note) note.textContent = CFG.copy.note; // hero note removed from the markup (item 9); copy kept for the config
    var foot = $('[data-pz-hb-footer]'); if (foot) foot.textContent = upper(tpl(CFG.copy.footer, V)); // strip removed (Round 5.7); copy kept for the config
    $$('[data-pz-hb-checkout-label]').forEach(function (el) { el.textContent = upper(CFG.copy.checkout); });
    $$('[data-pz-hb-more]').forEach(function (el) { el.textContent = CFG.copy.morePayment; });
    $$('[data-pz-hb-gifts-footer]').forEach(function (el) { el.textContent = CFG.copy.giftsFooter; });
    $$('[data-pz-hb-basket-title]').forEach(function (el) { el.textContent = upper(CFG.copy.basketTitle); });
    $('[data-pz-hb-viewbag]').textContent = upper(CFG.copy.viewBag);
    $('[data-pz-hb-total-label]').textContent = upper(CFG.copy.total);
    var strip = $('[data-pz-hb-tiers]');
    strip.style.setProperty('--pz-hb-n', N);
    strip.style.setProperty('--pz-hb-cols-d', 'repeat(' + (N - 1) + ', minmax(0, 1fr)) 1.6fr');
    strip.classList.add('pz-hb-tiers--m-' + CFG.mobileTierLayout);
    renderTabs();
  }

  function renderTiers(d) {
    var mob = isMobile(), h = '';
    TIERLIST.forEach(function (tr, i) {
      var t = tr.threshold, isUn = d.hit(i), isNext = i === d.nextIdx, best = i === N - 1, isShip = tr.kind === 'ship';
      var cls = 'pz-hb-tier ' + (isNext ? 'pz-hb-tier--next' : isUn ? 'pz-hb-tier--unlocked' : 'pz-hb-tier--locked') + (best ? ' pz-hb-tier--best' : '') + (state.fresh === i && !reduceMotion ? ' pz-hb-flip' : '');
      var tiles = (tr.ship ? [{ isShip: true, image: CFG.shipping.image, label: CFG.shipping.label }] : []).concat(giftsUpTo(i).map(function (x) { return { image: x.gift.image, label: x.gift.name + ', ' + x.gift.shade }; }));
      h += '<div class="' + cls + '" data-tier="' + i + '" role="listitem">';
      if (best) h += '<span class="pz-hb-tier__badge">' + upper(CFG.copy.bestValue) + '</span>';
      h += '<div class="pz-hb-tier__head"><span class="pz-hb-tier__spend">SPEND ' + money(t) + '</span>';
      h += isUn ? '<span class="pz-hb-tier__tick" role="img" aria-label="Unlocked">' + svg(I.tick, 12, 3) + '</span>' : '<span class="pz-hb-tier__lock" role="img" aria-label="Locked">' + svg(I.lock, 15, 2) + '</span>';
      h += '</div>';
      h += '<div class="pz-hb-tier__tiles" style="--n:' + tiles.length + '">';
      tiles.forEach(function (tl) { h += giftTile({ size: mob ? 'xs' : 'tier', unlocked: isUn, isShip: tl.isShip, image: tl.image, label: tl.label, fresh: state.fresh === i }); });
      h += '</div>';
      var gcount = giftsUpTo(i).length, cv = cumulativeValue(i);
      var giftLine = tpl(gcount === 1 ? CFG.copy.tierGift : CFG.copy.tierGifts, { value: money(cv) });
      var l1 = isShip ? CFG.copy.tierShipping : (tr.kind === 'both' ? tpl(CFG.copy.tierBoth, { giftLine: giftLine }) : giftLine);
      h += '<div class="pz-hb-tier__text"><div class="pz-hb-tier__l1">' + esc(l1) + '</div><div class="pz-hb-tier__l2">' + (isShip ? '' : esc(tierLabel(i, mob))) + '</div></div>';
      h += '</div>';
    });
    $('[data-pz-hb-tiers]').innerHTML = h;
    equalizeTierText();
  }
  // Every tier card reserves the tallest line-2 height, so line 1, line 2 and the card bottoms line up at any width
  function equalizeTierText() {
    ['.pz-hb-tier__l1', '.pz-hb-tier__l2'].forEach(function (sel) {
      var els = $$(sel); if (!els.length) return;
      els.forEach(function (el) { el.style.minHeight = ''; });
      if (isMobile()) return; // Mobile 2.1: no reserved heights on mobile (the full-width best card showed dead space)
      var max = 0; els.forEach(function (el) { max = Math.max(max, el.offsetHeight); });
      els.forEach(function (el) { el.style.minHeight = max + 'px'; });
    });
  }

  function renderProgress(d) {
    var msg = $('[data-pz-hb-msg]'); if (msg) msg.innerHTML = progressMsg(d);          // visually hidden live region
    var fill = $('[data-pz-hb-fill]'); if (fill) fill.style.width = barPct(d.tsub) + '%';
    var markers = $('[data-pz-hb-markers]');                                           // full section removed (Oct 2026); kept for the config
    if (markers) {
      var h = '';
      TIERS.forEach(function (t, i) {
        var isUn = d.hit(i);
        h += '<div class="pz-hb-marker' + (isUn ? ' is-unlocked' : '') + '" style="left:' + POS[i] + '%">';
        h += '<div class="pz-hb-marker__dot' + (state.fresh === i && !reduceMotion ? ' pz-hb-pop' : '') + '">' + svg(TIERLIST[i].gifts.length ? I.gift : I.truck, 20, 1.8) + '</div>';
        h += '<div class="pz-hb-marker__label">' + money(t) + '</div></div>';
      });
      markers.innerHTML = h;
    }
    $$('[data-pz-hb-minifill]').forEach(function (el) { el.style.width = barPct(d.tsub) + '%'; });
    var ms = $('[data-pz-hb-msg-slim]'), fs = $('[data-pz-hb-fill-slim]');
    if (ms) ms.innerHTML = progressMsg(d);
    if (fs) fs.style.width = barPct(d.tsub) + '%';
  }

  // Progress band (Oct 2026): a fixed slim strip under the header; shown (.is-stuck, CSS fade) once the tier strip's
  // bottom has passed the header, hidden again when the strip comes back into view. Nothing in the flow changes.
  var prog = $('[data-pz-hb-prog]'), progPanel = $('[data-pz-hb-prog-panel]'), bandTicking = false;
  function measureProg() { updateBand(); }
  function updateBand() {
    if (!prog) return;
    var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pz-hb-top')) || 97;
    var tiers = $('[data-pz-hb-tiers]'), main = $('.pz-hb-main');
    var ref = tiers ? tiers.getBoundingClientRect().bottom : prog.getBoundingClientRect().top;
    var band = parseFloat(getComputedStyle(root).getPropertyValue('--pz-hb-band')) || 64;
    var gridOn = !main || main.getBoundingClientRect().bottom > top + band; // released once the grid area has scrolled past (lower sections below)
    prog.classList.toggle('is-stuck', ref <= top + 1 && gridOn);
  }
  function onScroll() { if (bandTicking) return; bandTicking = true; requestAnimationFrame(function () { bandTicking = false; updateBand(); }); }
  // body#m-theme is the theme's scroll container; listen on both to be safe
  document.body.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('scroll', onScroll, { passive: true, capture: true });

  /* ========================================================================
     Product grid (Liquid-rendered cards): tabs, NEW badge, swatch cap, button price
     ======================================================================== */
  var CARDS = $$('[data-pz-card]');

  function cardInfo(card) {
    return { title: card.getAttribute('data-pz-title') || '', handle: card.getAttribute('data-pz-handle') || '', type: card.getAttribute('data-pz-type') || '', tags: (card.getAttribute('data-pz-tags') || '').split('|').filter(Boolean), collections: (card.getAttribute('data-pz-collections') || '').split('|').filter(Boolean) };
  }
  function initGrid() {
    CARDS.forEach(function (card) {
      var info = cardInfo(card);
      var tabs = CFG.tabs.filter(function (t) { return t.match(info); }).map(function (t) { return t.id; });
      card.setAttribute('data-tabs', tabs.join(' '));
      var badge = $('[data-pz-new]', card);
      if (badge) { badge.textContent = upper(CFG.copy.newBadge); badge.hidden = tabs.indexOf('new') < 0; }
      card.dataset.qty = '1';
      capSwatches(card);
      updateCardBtn(card);
    });
    applyTab();
  }
  function applyTab() {
    CARDS.forEach(function (card) { card.hidden = (card.getAttribute('data-tabs') || '').split(' ').indexOf(state.tab) < 0; });
  }
  function renderTabs() {
    $('[data-pz-hb-tabs]').innerHTML = CFG.tabs.map(function (t) {
      return '<button type="button" class="pz-hb-tab' + (state.tab === t.id ? ' is-active' : '') + '" data-tab="' + t.id + '" aria-pressed="' + (state.tab === t.id) + '">' + esc(upper(t.label)) + '</button>';
    }).join('');
  }
  // Collection-page swatch cap: first N swatches, then "+N" (reveals the rest here)
  function capSwatches(card) {
    var picker = $('[data-pcard-variant-picker]', card);
    if (!picker) return;
    var labels = $$('.m-product-option--node__label', picker).filter(function (l) { return !l.classList.contains('m-product-option--more-option'); });
    if (!CFG.swatchLimit || labels.length <= CFG.swatchLimit) return;
    var extra = labels.slice(CFG.swatchLimit);
    extra.forEach(function (l) { (l.closest('.m-product-option--swatch') || l).classList.add('pz-swatch-hidden'); });
    var more = document.createElement('button');
    more.type = 'button'; more.className = 'pz-hb-card__swatch-more'; more.textContent = '+' + extra.length;
    more.setAttribute('aria-label', 'Show ' + extra.length + ' more shades');
    more.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      extra.forEach(function (l) { (l.closest('.m-product-option--swatch') || l).classList.remove('pz-swatch-hidden'); });
      more.remove();
    });
    var host = picker.querySelector('swatch-color, swatch-image, .m-product-option--content') || picker;
    host.appendChild(more);
  }
  // Button text: "ADD TO BUNDLE | $26.00" (price × qty, follows the selected shade)
  function updateCardBtn(card) {
    var btn = $('[data-add]', card), label = $('[data-pz-add-label]', card), price = $('[data-pz-add-price]', card);
    if (!btn) return;
    var available = card.getAttribute('data-pz-available') !== 'false';
    var qty = cardQty(card), cents = Number(card.getAttribute('data-pz-price') || 0);
    btn.disabled = !available; btn.classList.toggle('disabled', !available);
    card.classList.toggle('is-soldout', !available);
    $$('[data-step]', card).forEach(function (b) { b.disabled = !available; });
    if (!available) { if (label) label.textContent = CFG.copy.soldOut; if (price) price.textContent = ''; fitBtn(btn); return; }
    if (label && !btn.classList.contains('is-added')) label.textContent = isMobile() || btn.classList.contains('pz-fit-6') ? CFG.copy.addMobile : CFG.copy.addDesktop;
    if (price) price.textContent = ' | ' + price2(cents * qty);
    if (isMobile()) FIT.forEach(function (c) { btn.classList.remove(c); }); else fitBtn(btn); // Mobile 3.3: never shrink on mobile
  }
  // Mobile 2.4: the card has no stepper on mobile (collection-page CTA) — one unit per tap; the quick view carries a stepper
  function cardQty(card) { return isMobile() ? 1 : Number(card.dataset.qty || 1); }
  // Fit fallbacks, in order, until the label fits on one line (as pz-variant-card.js pzFitCta)
  var FIT = ['pz-fit-1', 'pz-fit-2', 'pz-fit-3', 'pz-fit-4', 'pz-fit-5', 'pz-fit-6'];
  function fitBtn(btn) {
    var label = $('[data-pz-add-label]', btn);
    FIT.forEach(function (c) { btn.classList.remove(c); });
    if (isMobile()) return;
    if (label && !btn.disabled && !btn.classList.contains('is-added')) label.textContent = CFG.copy.addDesktop;
    var fits = function () { return btn.scrollWidth <= btn.clientWidth + 1; };
    if (btn.clientWidth === 0 || fits()) return;
    for (var i = 0; i < FIT.length; i++) {
      btn.classList.add(FIT[i]);
      if (FIT[i] === 'pz-fit-6' && label && !btn.disabled) label.textContent = CFG.copy.addMobile;
      if (fits()) break;
    }
  }
  function fitAllBtns() { CARDS.forEach(function (c) { if (!c.hidden) updateCardBtn(c); }); }

  // Shade switched by the theme (product-card-swatch.js) + pz-variant-card.js → follow price / availability
  document.addEventListener('pz:variant-card:change', function (e) {
    var card = e.target.closest && e.target.closest('[data-pz-card]');
    if (!card || !e.detail || !e.detail.variant) return;
    var v = e.detail.variant;
    card.setAttribute('data-pz-price', v.price);
    card.setAttribute('data-pz-available', v.available ? 'true' : 'false');
    updateCardBtn(card);
    var qvb = $('[data-pz-qv]', card);
    if (qvb && v.title) qvb.setAttribute('aria-label', 'Quick view ' + (card.getAttribute('data-pz-title') || '') + ' \u2013 ' + v.title);
  });
  // Fallback for the same information straight from the card's hidden variant select (no dependency on pz-variant-card.js)
  root.addEventListener('click', function (e) {
    var label = e.target.closest && e.target.closest('.m-product-option--node__label');
    if (!label) return;
    var card = label.closest('[data-pz-card]'); if (!card) return;
    setTimeout(function () {
      var title = label.getAttribute('data-value') || '';
      var opt = $$('select.product-variant option', card).filter(function (o) { return o.getAttribute('data-variant-title') === title; })[0];
      if (!opt) return;
      card.setAttribute('data-pz-price', opt.getAttribute('data-variant-price') || card.getAttribute('data-pz-price'));
      card.setAttribute('data-pz-available', opt.getAttribute('data-variant-available') === 'soldout' ? 'false' : 'true');
      updateCardBtn(card);
    }, 30);
  });

  /* ========================================================================
     Basket (desktop sidebar: products scroll, gifts→checkout pinned; mobile sheet)
     ======================================================================== */
  function productsHTML(d) {
    var h = '<div class="pz-hb-sec"><div class="pz-hb-label pz-hb-label--grey">' + esc(upper(CFG.copy.productsLabel)) + '</div>';
    if (!d.lines.length) {
      h += '<div class="pz-hb-empty"><div class="pz-hb-empty__icon">' + svg(I.gift, 22, 1.6) + '</div><div><div class="pz-hb-empty__title">' + esc(upper(CFG.copy.emptyTitle)) + '</div><div class="pz-hb-empty__note">' + esc(tpl(CFG.copy.emptyNote, V)) + '</div></div></div>';
    } else {
      d.lines.forEach(function (it) {
        var shade = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
        var img = it.featured_image && it.featured_image.url ? imgW(it.featured_image.url, 160) : (it.image ? imgW(it.image, 160) : '');
        h += '<div class="pz-hb-line" data-key="' + esc(it.key) + '">' + (img ? '<img class="pz-hb-line__img" src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="72" height="72" loading="lazy">' : '<div class="pz-hb-line__img"></div>');
        h += '<div class="pz-hb-line__body"><div class="pz-hb-line__row"><div class="pz-hb-line__name">' + esc(upper(it.product_title)) + '</div><div class="pz-hb-line__price">' + priceFromCents(it.final_line_price) + '</div></div>';
        h += '<div class="pz-hb-line__shade">' + esc(shade) + '</div>';
        h += '<div class="pz-hb-stepper pz-hb-stepper--sm"><button type="button" class="pz-hb-stepper__btn" data-line-step="-1" aria-label="Decrease quantity">' + svg(I.minus, 14) + '</button><span class="pz-hb-stepper__val">' + it.quantity + '</span><button type="button" class="pz-hb-stepper__btn" data-line-step="1" aria-label="Increase quantity"' + (it.quantity >= CFG.maxLineQty ? ' disabled' : '') + '>' + svg(I.plus, 14) + '</button></div>';
        h += '</div></div>';
      });
    }
    return h + '</div>';
  }
  function midHTML(d) {
    var mob = isMobile();
    var h = '<div class="pz-hb-sec"><div class="pz-hb-sec__head"><div class="pz-hb-label">' + esc(upper(CFG.copy.giftsLabel)) + '</div><div class="pz-hb-label pz-hb-label--grey pz-hb-label--tight">' + esc(upper(tpl(CFG.copy.unlockedShort, { n: d.slotsUnlocked, total: SLOTS.length }))) + '</div></div>';
    h += '<div class="pz-hb-slots" style="--n:' + SLOTS.length + '">';
    SLOTS.forEach(function (sl) {
      var t = sl.threshold, un = d.hit(sl.tier), fresh = state.fresh === sl.tier;
      if (sl.ship) h += giftTile({ size: 'md', unlocked: un, isShip: true, image: CFG.shipping.image, label: CFG.shipping.label, line1: CFG.copy.tierShipping, line2: '', helper: un ? '' : tpl(CFG.copy.unlocksAt, { t: money(t) }), fresh: fresh });
      else { var g = sl.g; h += giftTile({ size: 'md', unlocked: un, image: g.image, alt: g.name + ', ' + g.shade, label: g.label, line1: tpl(CFG.copy.slotGift, { value: money(sl.value) }), line2: slotName(sl.gi, mob), helper: un ? '' : tpl(CFG.copy.unlocksAt, { t: money(t) }), fresh: fresh }); }
    });
    h += '</div></div>';
    h += '<div class="pz-hb-sum"><div class="pz-hb-sum__row"><span>' + esc(CFG.copy.subtotal) + '</span><span>' + priceFromCents(d.cents) + '</span></div>';
    var shipIdx = TIERLIST.findIndex(function (x) { return x.ship; });
    if (shipIdx >= 0 && d.hit(shipIdx)) h += '<div class="pz-hb-sum__row"><span>' + esc(CFG.copy.shippingRow) + '</span><span class="pz-hb-sum__free">' + esc(CFG.copy.shippingFree) + '</span></div>';
    h += '<div class="pz-hb-sum__gifts"><span>' + svg(I.gift, 16, 1.8) + esc(CFG.copy.giftsRow) + '</span><span>' + esc(tpl(CFG.copy.giftsValue, { value: money(d.giftValue) })) + '</span></div>';
    h += '<div class="pz-hb-sum__div"></div>';
    h += '<div class="pz-hb-sum__total"><span>' + esc(upper(CFG.copy.total)) + '</span><span>' + priceFromCents(d.cents) + '</span></div></div>';
    h += '<div class="pz-hb-nudge">' + svg(I.gift, 16, 1.8) + '<span>' + esc(nudge(d)) + '</span></div>';
    return h;
  }

  function renderBasket(d) {
    var products = productsHTML(d), mid = midHTML(d);
    var prodEl = $('[data-pz-hb-products]'), midEl = $('[data-pz-hb-mid]'), altEl = $('[data-pz-hb-mid-alt]');
    if (prodEl) prodEl.innerHTML = products;
    updateFade();
    if (midEl && altEl) {
      if (state.asideMode === 'cta') { altEl.innerHTML = mid; midEl.innerHTML = ''; }
      else { midEl.innerHTML = mid; altEl.innerHTML = ''; }
    }
    $$('[data-pz-hb-basket-body]').forEach(function (el) { el.innerHTML = products + mid; });
    $$('[data-pz-hb-count]').forEach(function (el) { el.textContent = upper(countLabel(d.count)); });
    $$('[data-pz-hb-total]').forEach(function (el) { el.textContent = priceFromCents(d.cents); });
    $('[data-pz-hb-unlocked]').textContent = tpl(CFG.copy.unlockedLong, { n: d.slotsUnlocked, total: SLOTS.length });
    $('[data-pz-hb-nudge]').textContent = nudge(d);
    var th = '';
    d.lines.slice(0, 3).forEach(function (it) {
      var img = it.featured_image && it.featured_image.url ? imgW(it.featured_image.url, 96) : '';
      th += img ? '<img src="' + esc(img) + '" alt="' + esc(it.product_title) + '" width="36" height="36" loading="lazy">' : '<span class="pz-hb-thumb--blank"></span>';
    });
    if (d.lines.length > 3) th += '<span class="pz-hb-thumbs__more">+' + (d.lines.length - 3) + '</span>';
    $('[data-pz-hb-thumbs]').innerHTML = th;
    fitAside();
  }

  // Keep CHECKOUT (and ideally gifts → checkout) fully on screen: compact first, then only the CTAs stay pinned.
  // bottom fade on the products scroll area, only while there is more content below
  function updateFade() {
    var sc = $('[data-pz-hb-aside-scroll]'); if (!sc) return;
    if (!$('.pz-hb-aside__fade', sc)) { var f = document.createElement('div'); f.className = 'pz-hb-aside__fade'; f.setAttribute('aria-hidden', 'true'); sc.appendChild(f); }
    sc.classList.toggle('has-more', sc.scrollHeight - sc.scrollTop - sc.clientHeight > 2);
  }
  (function () { var sc = $('[data-pz-hb-aside-scroll]'); if (sc) sc.addEventListener('scroll', updateFade, { passive: true }); })();

  function fitAside() {
    var aside = $('[data-pz-hb-aside]'), pinned = $('[data-pz-hb-pinned]'), midEl = $('[data-pz-hb-mid]'), altEl = $('[data-pz-hb-mid-alt]');
    if (!aside || !pinned || isMobile()) return;
    var top = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--pz-hb-top')) || 97;
    var band = parseFloat(getComputedStyle(root).getPropertyValue('--pz-hb-band')) || 94;
    var bandGap = parseFloat(getComputedStyle(root).getPropertyValue('--pz-hb-band-gap')) || 20;
    var avail = window.innerHeight - top - band - bandGap - 24;
    var minScroll = 240; // header + the full empty-state box, or one full product line, above the pinned part
    aside.classList.remove('pz-hb-aside--compact');
    if (state.asideMode !== 'full') { state.asideMode = 'full'; midEl.innerHTML = altEl.innerHTML; altEl.innerHTML = ''; }
    if (pinned.offsetHeight <= avail - minScroll) return;
    aside.classList.add('pz-hb-aside--compact');
    if (pinned.offsetHeight <= avail - minScroll) return;
    state.asideMode = 'cta';
    altEl.innerHTML = midEl.innerHTML; midEl.innerHTML = '';
    updateFade();
  }

  // Toast: inside the basket, overlaid under the YOUR BUNDLE header row (never clipped by the band).
  // Desktop fallback: if that spot is off screen (e.g. page top, basket below the fold), the fixed toast
  // shows instead, aligned to the basket column just under the header / stuck band.
  function renderToast() {
    var hdr = document.querySelector('.m-section-header');
    var top = hdr ? hdr.getBoundingClientRect().bottom : 90;
    var html = state.toast < 0 ? '' : '<div class="pz-hb-toast__box' + (reduceMotion ? '' : ' pz-hb-slide') + '"><span class="pz-hb-toast__tick">' + svg(I.tick, 14, 2.6) + '</span><span>' + esc(toastText(state.toast)) + '</span></div>';
    var inAside = $('.pz-hb-aside [data-pz-hb-toast]'), fixed = $('.pz-hb-toast--m');
    var useFixed = isMobile();
    if (useFixed) { var slimM = $('[data-pz-hb-prog-slim]'); if (prog && prog.classList.contains('is-stuck') && slimM) top = slimM.getBoundingClientRect().bottom; }
    var aside = $('[data-pz-hb-aside]');
    if (!useFixed && aside && state.toast >= 0) {
      var ar = aside.getBoundingClientRect(), tTop = ar.top + 62;
      var slim = $('[data-pz-hb-prog-slim]');
      var band = prog && prog.classList.contains('is-stuck') && slim ? slim.getBoundingClientRect().bottom : top;
      if (tTop < band || tTop + 60 > window.innerHeight) {
        useFixed = true;
        fixed.style.left = Math.round(ar.left + 16) + 'px';
        fixed.style.width = Math.round(ar.width - 32) + 'px';
        fixed.style.right = 'auto';
        fixed.classList.add('is-desktop');
        top = band;
      }
    }
    if (!useFixed) { fixed.style.left = ''; fixed.style.width = ''; fixed.style.right = ''; fixed.classList.remove('is-desktop'); }
    [inAside, fixed].forEach(function (el, i) {
      if (!el) return;
      var show = state.toast >= 0 && ((i === 1) === useFixed);
      el.innerHTML = show ? html : '';
      el.classList.toggle('is-on', show);
      el.style.setProperty('--pz-hb-toast-top', Math.max(12, top + 12) + 'px');
    });
  }

  // Renders are memoised on a state key so re-syncs that land on the same state touch nothing
  // (no re-animation of tiles / markers, no toast re-slide).
  var lastKeys = { tiers: '', prog: '', basket: '', toast: '' };
  function renderAll() {
    var d = derive(state.cart);
    var tk = d.sub + '|' + state.fresh + '|' + isMobile();
    if (tk !== lastKeys.tiers) { lastKeys.tiers = tk; renderTiers(d); }
    if (tk !== lastKeys.prog) { lastKeys.prog = tk; renderProgress(d); }
    var bk = tk + '|' + d.lines.map(function (l) { return l.key + ':' + l.quantity + ':' + l.final_line_price; }).join(',') + '|' + state.asideMode;
    if (bk !== lastKeys.basket) { lastKeys.basket = bk; renderBasket(d); }
    var tok = state.toast >= 0 ? 'on:' + state.toast : 'off';
    if (tok !== lastKeys.toast) { lastKeys.toast = tok; renderToast(); }
    root.classList.toggle('pz-hb--toast-on', state.toast >= 0);
    root.classList.toggle('pz-hb--empty', !d.lines.length);
  }

  /* ========================================================================
     Cart API — serialised writes, debounced steppers, resync for the app
     ======================================================================== */
  var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  var resyncTimers = [];

  function fetchJSON(url, opts) {
    return fetch(url, Object.assign({ credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  /* ---- Single state pipeline ----------------------------------------------------------------
     Every cart response (mutation result, re-sync, cart:refresh) goes through setCart(). Guards:
       1. sequence: each read is numbered; an older response never overwrites a newer one
       2. token: the EG app builds a temporary duplicate cart (new token) while it works out final prices;
          a response with another token is ignored unless it keeps coming back for 4s with nothing in flight
       3. settle window: for 4.5s after any mutation, a response with fewer paid units than we expect
          (an intermediate / partial read) is ignored and re-read later
     Unlock feedback then keys off highestUnlockedShown (state.maxUnlocked): one toast per add, highest
     new tier only; downgrades silent; re-syncs that land on the same state do nothing. */
  var cartSeq = 0, cartApplied = 0, cartToken = null;
  var settleUntil = 0, expectedCount = null, pendingOps = 0;
  var suspect = { token: null, since: 0 };
  var retryTimer = null;
  function getCart() {
    var id = ++cartSeq;
    return fetchJSON(rootUrl + 'cart.js?pz_hb=' + Date.now()).then(function (c) { c.__seq = id; return c; });
  }
  function unitCount(cart) { return paidLines(cart).reduce(function (s, it) { return s + it.quantity; }, 0); }
  function retryLater(ms) {
    clearTimeout(retryTimer);
    retryTimer = setTimeout(function () { getCart().then(function (c) { setCart(c, { source: 'retry' }); }).catch(function () {}); }, ms || 1200);
  }
  function trustCart(cart) {
    if (!cart || !cart.items) return false;
    if (cart.__seq && cart.__seq < cartApplied) return false;
    var now = Date.now();
    if (now >= settleUntil && pendingOps === 0) expectedCount = null;
    if (!cartToken) { cartToken = cart.token; return true; }
    if (cart.token && cart.token !== cartToken) {
      if (suspect.token !== cart.token) suspect = { token: cart.token, since: now };
      if (now - suspect.since < 4000 || now < settleUntil || pendingOps > 0) { retryLater(); return false; }
      cartToken = cart.token; suspect = { token: null, since: 0 };
      return true;
    }
    suspect = { token: null, since: 0 };
    if ((now < settleUntil || pendingOps > 0) && expectedCount != null && unitCount(cart) < expectedCount) { retryLater(); return false; }
    return true;
  }
  function setCart(cart, opts) {
    opts = opts || {};
    if (!trustCart(cart)) return;
    if (cart.__seq) cartApplied = cart.__seq;
    if (cart.currency && cart.currency !== activeCurrency) setCartCurrency(cart.currency);
    var after = paidSubtotal(cart);
    var afterCents = paidCents(cart);
    var unlockedAfter = TIERLIST.filter(function (x) { return afterCents >= x.threshold * 100; }).length;
    state.cart = cart;
    if (state.maxUnlocked != null && !opts.silent && unlockedAfter > state.maxUnlocked) {
      var hit = unlockedAfter - 1;                       // highest newly crossed tier only
      state.toast = hit; state.fresh = hit;
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { state.toast = -1; state.fresh = -1; renderAll(); }, CFG.toastMs);
    }
    state.maxUnlocked = unlockedAfter;                   // lowered silently on downgrades
    state.lastPaid = after;
    renderAll();
    if (state.fresh >= 0) setTimeout(function () { state.fresh = -1; }, 700);
  }
  function emitThemeCartUpdate(cart) {
    try {
      if (window.MinimogEvents && window.MinimogTheme && window.MinimogTheme.pubSubEvents) {
        window.MinimogEvents.emit(window.MinimogTheme.pubSubEvents.cartUpdate, { source: 'pz-holiday-bundle', cart: cart });
      }
    } catch (e) { /* no-op */ }
  }
  function scheduleResync() {
    resyncTimers.forEach(clearTimeout); resyncTimers = [];
    CFG.resyncDelaysMs.forEach(function (ms) {
      resyncTimers.push(setTimeout(function () { getCart().then(function (c) { setCart(c, { source: 'resync+' + ms }); }).catch(function () {}); }, ms));
    });
  }
  var resyncSoon = debounce(function () { getCart().then(function (c) { setCart(c, { source: 'event' }); }).catch(function () {}); }, 300);

  function enqueue(fn, expected) {
    pendingOps++;
    if (expected != null) expectedCount = expected;
    settleUntil = Date.now() + 4500;
    queue = queue.then(fn, fn).then(function (cart) {
      pendingOps--; settleUntil = Date.now() + 4500;
      if (cart && cart.items) { if (!cart.__seq) cart.__seq = ++cartSeq; setCart(cart); emitThemeCartUpdate(cart); scheduleResync(); }
      return cart;
    }).catch(function (err) {
      pendingOps--;
      console.warn('[pz-hb] cart error', err);
      expectedCount = null;
      getCart().then(function (c) { setCart(c, { silent: true }); }).catch(function () {});
    });
    return queue;
  }

  // Add (card button or quick-view button): theme spinner while posting (incl. the app's delay), then "ADDED" briefly,
  // same width throughout; the basket / toasts follow through setCart exactly as before
  function addFromCard(card) {
    var input = card.querySelector('input[name="id"]');
    var variantId = input ? input.value : null; if (!variantId) return;
    return addVariant(variantId, cardQty(card), $('[data-add]', card), function () { updateCardBtn(card); });
  }
  function addVariant(variantId, qty, btn, after) {
    if (!btn || btn.disabled || btn.classList.contains('m-spinner-loading')) return Promise.resolve();
    var label = $('[data-pz-add-label]', btn), priceEl = $('[data-pz-add-price]', btn);
    btn.style.minWidth = btn.offsetWidth + 'px';
    btn.classList.add('m-spinner-loading');
    var base = expectedCount != null ? expectedCount : unitCount(state.cart);
    return enqueue(function () {
      var existing = paidLines(state.cart).filter(function (it) { return String(it.variant_id) === String(variantId) && !(it.properties && Object.keys(it.properties).length); })[0];
      if (existing) {
        var target = Math.min(CFG.maxLineQty, existing.quantity + qty);
        if (target === existing.quantity) return getCart();
        return fetchJSON(rootUrl + 'cart/change.js', { method: 'POST', body: JSON.stringify({ id: existing.key, quantity: target }) });
      }
      return fetchJSON(rootUrl + 'cart/add.js', { method: 'POST', body: JSON.stringify({ items: [{ id: Number(variantId), quantity: Math.min(qty, CFG.maxLineQty) }] }) })
        .then(function () { return getCart(); });
    }, base + qty).then(function () {
      btn.classList.remove('m-spinner-loading');
      btn.classList.add('is-added');
      var savedPrice = priceEl ? priceEl.textContent : '';
      if (label) label.textContent = upper(CFG.copy.added);
      if (priceEl) priceEl.textContent = '';
      setTimeout(function () {
        btn.classList.remove('is-added');
        if (priceEl) priceEl.textContent = savedPrice;
        btn.style.minWidth = '';
        if (after) after();
      }, CFG.addedMs);
    });
  }

  var pendingLine = {};
  function stepLine(key, delta) {
    var it = (state.cart.items || []).filter(function (x) { return x.key === key; })[0];
    if (!it) return;
    var target = Math.max(0, Math.min(CFG.maxLineQty, (pendingLine[key] != null ? pendingLine[key] : it.quantity) + delta));
    pendingLine[key] = target;
    it.quantity = target; it.final_line_price = it.final_price * target; it.line_price = it.price * target;
    if (target === 0) state.cart.items = state.cart.items.filter(function (x) { return x.key !== key; });
    renderAll();
    flushLine(key);
  }
  var flushLine = debounce(function () {
    Object.keys(pendingLine).forEach(function (key) {
      var q = pendingLine[key]; delete pendingLine[key];
      enqueue(function () { return fetchJSON(rootUrl + 'cart/change.js', { method: 'POST', body: JSON.stringify({ id: key, quantity: q }) }); }, unitCount(state.cart));
    });
  }, 250);

  /* ========================================================================
     Quick view = shared component (assets/pz-quick-view.js, loaded before this file). Bundle mode: the "+" on a card
     opens the dialog for that shade (data-pz-qv-open on the button, variant from the card's hidden input); adds go
     through addVariant → the same cart pipeline, basket, toasts and ADDED state. Prices = this page's formatters.
     ======================================================================== */
  if (window.PZQuickView) {
    window.PZQuickView.configure({
      mode: 'bundle',
      add: function (v, qty, btn, done) { return addVariant(v.id, qty, btn, done); },
      money: priceFromCents,
      buttonMoney: price2,
      labels: { add: CFG.copy.addMobile, soldOut: CFG.copy.soldOut, added: CFG.copy.added },
      maxQty: CFG.maxStepperQty,
      addedMs: CFG.addedMs
    });
  } else console.warn('[pz-hb] pz-quick-view.js missing');

  /* ========================================================================
     Mobile basket sheet (dialog)
     ======================================================================== */
  var sheet = $('[data-pz-hb-sheet]'), overlay = $('[data-pz-hb-overlay]'), bagBtn = $('[data-pz-hb-open-sheet]');
  var lastFocus = null;
  function openSheet() {
    if (state.sheet) return;
    state.sheet = true; lastFocus = document.activeElement;
    root.classList.add('pz-hb--sheet-open'); document.documentElement.classList.add('pz-hb-lock'); document.body.classList.add('pz-hb-lock');
    sheet.removeAttribute('hidden'); overlay.removeAttribute('hidden');
    var close = $('[data-pz-hb-close]', sheet); if (close) close.focus();
    document.addEventListener('keydown', trapKeys);
  }
  function closeSheet() {
    if (!state.sheet) return;
    state.sheet = false;
    root.classList.remove('pz-hb--sheet-open'); document.documentElement.classList.remove('pz-hb-lock'); document.body.classList.remove('pz-hb-lock');
    sheet.setAttribute('hidden', ''); overlay.setAttribute('hidden', '');
    document.removeEventListener('keydown', trapKeys);
    if (lastFocus && lastFocus.focus) lastFocus.focus(); else if (bagBtn) bagBtn.focus();
  }
  function trapKeys(e) {
    if (e.key === 'Escape') { e.preventDefault(); closeSheet(); return; }
    if (e.key !== 'Tab') return;
    var f = $$('button:not([disabled]), a[href], input, [tabindex]:not([tabindex="-1"])', sheet).filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }
  (function () {
    var head = $('[data-pz-hb-sheet-head]'), y0 = null;
    if (!head) return;
    head.addEventListener('touchstart', function (e) { y0 = e.touches[0].clientY; }, { passive: true });
    head.addEventListener('touchmove', function (e) { if (y0 != null && e.touches[0].clientY - y0 > 80) { y0 = null; closeSheet(); } }, { passive: true });
    head.addEventListener('touchend', function () { y0 = null; });
  })();

  /* ========================================================================
     Theme cart drawer: never on this page. Pop-ups: never on this page.
     ======================================================================== */
  (function suppressDrawer() {
    var drawer = document.querySelector('m-cart-drawer, .m-cart-drawer');
    if (!drawer) return;
    var noop = function () { return undefined; };
    var patch = function () { try { drawer.open = noop; } catch (e) { /* no-op */ } };
    patch();
    if (window.customElements && customElements.whenDefined) customElements.whenDefined('m-cart-drawer').then(patch).catch(function () {});
    var reset = function () {
      if (drawer.classList.contains('m-cart-drawer--active')) {
        drawer.classList.remove('m-cart-drawer--active');
        document.documentElement.style.overflow = '';
        document.body.classList.remove('lp-cart-drawer-is-open');
      }
    };
    new MutationObserver(reset).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    reset();
  })();
  (function suppressPopups() {
    var hide = function (el) {
      if (!el || el.nodeType !== 1 || root.contains(el)) return;
      var cls = String(el.className || '');
      if (cls.indexOf('kl-private-reset-css') >= 0 || cls.indexOf('klaviyo-form') >= 0 || /^kl-/.test(el.id || '')) el.style.setProperty('display', 'none', 'important');
    };
    Array.prototype.forEach.call(document.body.children, hide);
    new MutationObserver(function (muts) { muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, hide); }); }).observe(document.body, { childList: true });
  })();

  // Header bag icon → the on-page basket instead of the drawer
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('.m-cart-icon-bubble, a[href$="/cart"]');
    if (!a || root.contains(a)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    if (isMobile()) openSheet();
    else { var aside = $('[data-pz-hb-aside]'); if (aside) aside.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' }); }
  }, true);

  /* ========================================================================
     Events
     ======================================================================== */
  root.addEventListener('click', function (e) {
    var t = e.target.closest ? e.target : null; if (!t) return;
    var btn;
    if ((btn = t.closest('[data-tab]'))) { state.tab = btn.getAttribute('data-tab'); renderTabs(); applyTab(); fitAllBtns(); window.dispatchEvent(new Event('resize')); return; }
    var card = t.closest('[data-pz-card]');
    if (card) {
      if (t.closest('[data-pz-qv]')) return; // handled by pz-quick-view.js (document-level trigger)
      if ((btn = t.closest('[data-step]'))) {
        var q = Number(card.dataset.qty || 1);
        card.dataset.qty = String(Math.max(1, Math.min(CFG.maxStepperQty, q + Number(btn.getAttribute('data-step')))));
        var qtyEl = $('[data-qty]', card); if (qtyEl) qtyEl.textContent = card.dataset.qty;
        updateCardBtn(card); return;
      }
      if (t.closest('[data-add]')) { addFromCard(card); return; }
    }
    var line = t.closest('[data-key]');
    if (line && (btn = t.closest('[data-line-step]'))) { stepLine(line.getAttribute('data-key'), Number(btn.getAttribute('data-line-step'))); return; }
    if (t.closest('[data-pz-hb-open-sheet]')) { openSheet(); return; }
    if (t.closest('[data-pz-hb-close]') || t.closest('[data-pz-hb-overlay]')) { closeSheet(); return; }
    if (t.closest('[data-pz-hb-checkout]')) { window.location.href = rootUrl.replace(/\/$/, '') + '/checkout'; return; }
  });

  var mq = window.matchMedia('(max-width: 1023px)');
  var onMq = function () { if (state.cart) renderAll(); fitAllBtns(); if (!isMobile()) closeSheet(); measureBar(); };
  if (mq.addEventListener) mq.addEventListener('change', onMq); else mq.addListener(onMq);

  function measureBar() {
    var bar = $('[data-pz-hb-bar]');
    document.documentElement.style.setProperty('--pz-hb-bar-h', (bar && isMobile() ? bar.offsetHeight : 0) + 'px');
    var hdr = document.querySelector('.m-section-header');
    if (hdr) document.documentElement.style.setProperty('--pz-hb-top', Math.max(0, Math.round(hdr.getBoundingClientRect().bottom)) + 'px');
  }
  window.addEventListener('resize', debounce(function () { measureBar(); fitAllBtns(); fitAside(); measureProg(); equalizeTierText(); }, 150));
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { fitAllBtns(); fitAside(); equalizeTierText(); });
  // Shopify's wallet buttons render after load (skeleton → buttons): re-fit the pinned basket when they settle
  var refit = debounce(function () { measureBar(); fitAside(); }, 200);
  $$('[data-pz-hb-acc]').forEach(function (acc) { new MutationObserver(refit).observe(acc, { childList: true, subtree: true, attributes: true }); });
  window.addEventListener('load', refit);
  setTimeout(refit, 2500);
  setTimeout(refit, 5000);

  ['cart:refresh', 'cart:updated'].forEach(function (ev) {
    document.addEventListener(ev, resyncSoon); window.addEventListener(ev, resyncSoon);
  });
  document.addEventListener('visibilitychange', function () { if (!document.hidden) resyncSoon(); });

  /* ========================================================================
     Boot: rehydrate from the real cart
     ======================================================================== */
  if (root.getAttribute('data-pz-hb-currency')) { activeCurrency = root.getAttribute('data-pz-hb-currency'); priceSym = CFG.currencySymbols[activeCurrency] || (activeCurrency + ' '); }
  buildModel();
  renderStatic();
  measureBar();
  initGrid();
  measureProg();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(measureProg);
  window.addEventListener('load', measureProg);
  getCart().then(function (c) { setCart(c, { silent: true, source: 'boot' }); root.classList.add('pz-hb--ready'); measureBar(); fitAside(); })
    .catch(function () { setCart({ items: [] }, { silent: true }); root.classList.add('pz-hb--ready'); measureBar(); });

  window.PZ_HB = { config: CFG, state: state, derive: function () { return derive(state.cart); }, refresh: resyncSoon, fitAside: fitAside };
})();
